import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingPlanDefinition } from './types';

export function useBillingPlans() {
  const { data, error, isLoading, mutate } = useSWR<TBillingPlanDefinition[]>(
    'commenda-billing/catalog/plans',
    SWRFetcher({ method: 'GET' })
  );

  return { plans: data ?? [], error, isLoading, mutate };
}
